export default __webpack_public_path__ + "static/media/Brandon_light.f49b6cce.otf";